import { getApiBaseUrl } from './apiBase';
const API_BASE_URL = getApiBaseUrl();

export const announcementService = {
  // Get all active announcements (public)
  async getActive() {
    try {
      const response = await fetch(`${API_BASE_URL}/announcements`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.msg || 'Failed to fetch announcements');
      }
      
      return data.announcements || [];
    } catch (error) {
      console.error('Error fetching active announcements:', error);
      throw error;
    }
  },

  // Admin: Get all announcements
  async getAll() {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${API_BASE_URL}/announcements/admin`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.msg || 'Failed to fetch announcements');
      }
      
      return data.announcements || [];
    } catch (error) {
      console.error('Error fetching all announcements:', error);
      throw error;
    }
  },

  // Admin: Create new announcement
  async create(announcementData) {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${API_BASE_URL}/announcements`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(announcementData)
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.msg || 'Failed to create announcement');
      }
      
      return data.announcement;
    } catch (error) {
      console.error('Error creating announcement:', error);
      throw error;
    }
  },

  // Admin: Update announcement
  async update(id, updates) {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${API_BASE_URL}/announcements/${id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.msg || 'Failed to update announcement');
      }
      
      return data.announcement;
    } catch (error) {
      console.error('Error updating announcement:', error);
      throw error;
    }
  },

  // Admin: Delete announcement
  async delete(id) {
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await fetch(`${API_BASE_URL}/announcements/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.msg || 'Failed to delete announcement');
      }
      
      return data;
    } catch (error) {
      console.error('Error deleting announcement:', error);
      throw error;
    }
  }
};